import styled from "styled-components";

export const Container = styled.div `
    position: absolute;
    left: ${props => props.showFilters ? '0' : '-100%'};
    top: 0;
    width: 100dvw;
    height: 100dvh;
    background: #00000099;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
`

export const Content = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
    width: 25dvw;
    min-width: 400px;
    max-width: 1800px;
    height: max-content;
    max-height: 95dvh;
    background: #404040;
    padding: 20px 20px 50px 20px;
    border-radius: 5px;
    overflow-y: auto;
    box-shadow: 0 0 20px 5px #00000060;
    transform: ${props => props.showFilters ? 'scale(1)' : 'scale(0)'};
    transition: all .5s ease;
    
    .header-filters {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: sticky;
        top: -25px;
        padding: 20px 0;
        margin-bottom: 20px;
        background-image: linear-gradient(to bottom, #404040,rgb(64, 64, 64) , #40404000);
        z-index: 9;
    }

    .header-filters a, .header-filters button {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: #30303099;
        border: 2px solid #aaa;
        border-radius: 50%;
        padding: 10px;
        transition: all .3s ease;
    }

    .header-filters a:hover, .header-filters button:hover {
        border-color: #fff;
        background: #000;
    }

    .filter-group {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 400px;
        margin-bottom: 20px;
    }
    
    .filter-group label {
        color: #fff;
        font-size: 16px;
        margin-bottom: 5px;
    }

    span {
        margin: 0 5px;
    }

    select {
        border-radius: 5px;
        width: 100%;
        height: 40px;
    }

    .filter-row {
        display: flex;
        align-items: center;
    }

    .order-by {
        display: flex;
        align-items: center;
    }

    .order-button {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 40px;
        max-height: 40px;
        min-width: 40px;
        max-width: 40px;
        font-size: 1.2rem;
        margin-left: 5px;
        background: #3a7bd5;
        color: #fff;
        border: none;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            background: #2a5fa4;
        }
    }

    .span-order {
        text-align: center;
        margin-top: 5px;
        font-weight: 600;
        font-size: .8rem;
    }

    .div-bts-apply-changes {
        display: flex;
        margin-top: 20px;
    }

    .div-bts-apply-changes button {
        margin-top: 20px;
        background: #3a7bd5;
        color: #fff;
        border: none;
        padding: 10px;
        height: 50px;
        width: 100%;
        font-weight: 600;
        font-size: .8rem;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;

        i {
            margin-right: 5px;
        }

        &:hover {
            background: #2a5fa4;
        }
    }

    .bt-remove-filters {
        background:rgb(211, 0, 0) !important;
        margin-right: 10px;

        &:hover {
            background:hsl(0, 73.70%, 31.40%) !important;
        }
    }

    @media (max-width: 450px) {

        width: 90%;
        min-width: auto;
        padding: 10px 10px 30px 10px;

        .bt-remove-filters {
            margin-right: 5px;
        }

    }

`
